import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  AlertDialogCloseButton,
} from '@chakra-ui/react';

interface UnlinkEmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  email?: string;
  isLoading?: boolean;
}

export const UnlinkEmailModal: React.FC<UnlinkEmailModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  email = '',
  isLoading = false,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Unlink Email Address
          </AlertDialogHeader>
          <AlertDialogCloseButton />

          <AlertDialogBody>
            This application will be unlinked from the email address {email}, and the user account associated with that
            email address will be deleted.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} isDisabled={isLoading}>
              Cancel
            </Button>
            <Button
              variant="solid"
              bgColor="red.500"
              onClick={handleConfirm}
              ml={3}
              isLoading={isLoading}
              loadingText="Unlinking..."
            >
              Confirm
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
